import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HeaderTemplateData } from '../dialog-data.interface';


@UntilDestroy()
@Component({
  selector: 'confirm-delete-news-dialog',
  templateUrl: 'confirm-delete-news-dialog.html',
  styleUrls: ['confirm-delete-news-dialog.scss']
})
export class ConfirmDeleteNewsDialog implements OnInit {
    result:any;
    header: HeaderTemplateData = {
        title:{
            leftTopTitle:{
                title:{
                    text:"Confirm Delete",
                }
            },
        }
    }
    constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteNewsDialog>,
    @Inject(MAT_DIALOG_DATA)
        private _data:any
    ){
        console.log(this._data)
        if(_data!=null){
            this.result = _data
        }
    }

    ngOnInit(){

    }
    
  onSubmit(){
      this.dialogRef.close(true);
  }
}